// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

'use client';
export { I18nProvider as default, I18nProvider, I18nProviderProps } from './provider';
export { importMessages } from './dynamic';
